/**
 * @generated SignedSource<<7107c7b917957f7781b54fc4e210283e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TVTodoSubListItem_todo$data = {
  readonly body: string | null;
  readonly canChangeStatus: boolean;
  readonly canWrite: boolean;
  readonly expireAtDate: {
    readonly isoString: string;
  } | null;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly isOrg: boolean;
  readonly ordinal: string;
  readonly response: {
    readonly __typename: string;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooter_todo" | "TodoListItemHeader_todo" | "TodoListItemMainContentDetails_todo" | "TodoListItemMainContentText_todo" | "TodoListItemPriority_todo" | "TodoOverviewListItemMediumStatusAndPrio_Todo">;
  readonly " $fragmentType": "TVTodoSubListItem_todo";
};
export type TVTodoSubListItem_todo$key = {
  readonly " $data"?: TVTodoSubListItem_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVTodoSubListItem_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVTodoSubListItem_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentText_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemPriority_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooter_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemMediumStatusAndPrio_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentDetails_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemHeader_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "6aaf1481ca8749d5f1a8ef2248f5aa9d";

export default node;
